// extracted by mini-css-extract-plugin
module.exports = {"form":"userSummary_form__3n0QZ","tags":"userSummary_tags__3LvZ2"};